import { service } from '@/request/server'

// 穴位列表
export const acupointList = (params) => (
  service({
    url: '/Acupoint/acupointList',
    method: 'POST',
    data: params
  })
)

// 穴位详情
export const acupointDetail = (params) => (
  service({
    url: '/Acupoint/acupointDetail',
    method: 'GET',
    params
  })
)

// 添加/编辑穴位
export const saveAcupoint = (params) => (
  service({
    url: '/Acupoint/saveAcupoint',
    method: 'POST',
    data: params
  })
)

// 穴位分类列表
export const categoryList = (params) => (
  service({
    url: '/Acupoint_category/categoryList',
    method: 'GET',
    params
  })
)

// 穴位分类详情
export const categoryDetail = (params) => (
  service({
    url: '/Acupoint_category/categoryDetail',
    method: 'GET',
    params
  })
)

// 添加/编辑穴位分类
export const saveCategory = (params) => (
  service({
    url: '/Acupoint_category/saveCategory',
    method: 'POST',
    data: params
  })
)

// 删除穴位
export const delAcupoint = (params) => (
  service({
    url: '/Acupoint/delAcupoint',
    method: 'GET',
    params
  })
)

// 删除经络（穴位分类）
export const delAcupointCategory = (params) => (
  service({
    url: '/Acupoint_category/delAcupointCategory',
    method: 'GET',
    params
  })
)